import React from 'react';
import PropTypes from 'prop-types';

import AnnotationEditor from '../../components/AnnotationEditor';
import ViewAnnotation from '../../components/ViewAnnotation';

const AnnotationContainer = ({ readOnly, ...rest }) => {
  if (readOnly) {
    return <ViewAnnotation {...rest} />;
  }
  return <AnnotationEditor {...rest} />;
};

AnnotationContainer.defaultProps = {};

AnnotationContainer.propTypes = {
  readOnly: PropTypes.bool.isRequired
};

export default AnnotationContainer;
